import { Link } from "@tvg/fuse/link";
import { Typography } from "@tvg/fuse/typography";
import React from "react";

import styles from "./social.module.css";

import { FuseBrand } from "src/types/brand";

import { getBrandLinkList } from "./config";

export interface SocialSectionProps {
  brand: FuseBrand;
}

const SocialSection: React.FC<SocialSectionProps> = ({ brand }) => {
  const linkConfig = getBrandLinkList(brand as string).map((link) => ({
    ...link,
    ariaLabel: `${brand} on ${link.id}`,
    titleAttr: `${brand.toUpperCase() + brand.substring(1)} on ${link.id}`,
    imageAlt: `${link.id} logo`,
    targetAttr: "_blank",
    asDataUri: false,
  }));

  return (
    <div
      className={`${styles.footerSocialSection} footer__social-section`}
      data-testid="social-section"
    >
      <Typography
        size="1"
        tag="h3"
        type="heading"
        className={`${styles.footerSocialSection__title} footer__social-title`}
        dataTestId="social-section-title"
      >
        Let's get social
      </Typography>

      <ul
        className={`${styles.footerSocialSection__wrapper} footer__social-wrapper`}
      >
        {linkConfig.map((item, i) => {
          const { id, hrefAttr, Icon } = item;

          const upperCaseBrand = `${brand[0].toUpperCase() + brand.substring(1)}`;

          return (
            <li key={i}>
              <Link
                href={hrefAttr}
                dataTestId={`footer-social-link-${id.toLowerCase()}`}
                icon={<Icon />}
                aria-label={`${upperCaseBrand} logo`}
                rel="noopener"
                target="_blank"
                title={`${upperCaseBrand} on ${id}`}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default React.memo(SocialSection);
